<div class="modal-header">
    <span class="modal-title">Confirm Employee No</span>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <mat-form-field class="example-full-width">
        <mat-label>Confirm Employee No: </mat-label>
        <input matInput [(ngModel)]="requestBy" (keyup.enter)="submit()" #input>
    </mat-form-field>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
    <button type="button" ngbAutofocus class="btn btn-danger" (click)="submit()">Ok</button>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>